import { render, staticRenderFns } from "./hqcontact.vue?vue&type=template&id=bd51c130&scoped=true"
import script from "./hqcontact.vue?vue&type=script&lang=js"
export * from "./hqcontact.vue?vue&type=script&lang=js"
import style0 from "./hqcontact.vue?vue&type=style&index=0&id=bd51c130&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd51c130",
  null
  
)

export default component.exports